var _path, _path2, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoFullLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 32,
    viewBox: "0 0 160 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 4L4 10.5L16 17L28 10.5L16 4Z",
    fill: "#DBDDEA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 12.5V20C8 20 12 24 16 24C20 24 24 20 24 20V12.5",
    stroke: "#DBDDEA",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 36,
    y: 22,
    fontFamily: "Arial, sans-serif",
    fontWeight: "bold",
    fontSize: 20,
    fill: "#DBDDEA"
  }, "Study", /*#__PURE__*/React.createElement("tspan", {
    fill: "#FFD60A"
  }, "Hub"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoFullLight);
export default __webpack_public_path__ + "static/media/Logo-Full-Light.bf510f00993585178b1ceb9d0e437de1.svg";
export { ForwardRef as ReactComponent };